module.exports = __webpack_public_path__ + "public/img/pintaun.91528efb.png";